// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Hero pillars */
.about_pillars__CrjT6 {
  margin: 0;
  padding: var(--space-5) 0 0;
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-3) var(--space-6);
  border-top: 1px solid var(--color-border-on-dark);
  max-width: 46rem;
}
.about_pillars__CrjT6 li {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  font-size: 0.95rem;
  color: var(--color-text-muted-on-dark);
  white-space: nowrap;
}
.about_pillars__CrjT6 li::before {
  content: "";
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--kur-gold);
  box-shadow: 0 0 10px rgba(255, 215, 0, 0.7);
}

/* Intro on the left, copy on the right */
.about_split__zhsFy {
  display: grid;
  gap: var(--space-6);
  align-items: start;
}
@media (min-width: 1024px) {
  .about_split__zhsFy {
    grid-template-columns: minmax(0, 5fr) minmax(0, 7fr);
    gap: clamp(3rem, 6vw, 6rem);
  }
  .about_split__zhsFy > header {
    position: sticky;
    top: calc(var(--scroll-offset, 96px) + var(--space-4));
    margin-bottom: 0;
  }
}
.about_prose__Y1IJk {
  display: grid;
  gap: var(--space-4);
  max-width: 44rem;
  font-size: var(--text-body-lg);
  line-height: var(--leading-body);
  color: var(--color-text-muted);
}
.about_prose__Y1IJk p {
  margin: 0;
}
.about_prose__Y1IJk p:first-child {
  color: var(--color-ink);
}

.about_callout__lvH50 {
  position: relative;
  margin: clamp(3rem, 2rem + 4vw, 5rem) 0 0;
  padding: clamp(1.75rem, 1rem + 3vw, 3rem);
  border-radius: var(--radius-lg);
  background: linear-gradient(135deg, var(--color-ink), var(--color-ink-deep));
  color: var(--color-text-on-dark);
  box-shadow: var(--shadow-lg);
  overflow: hidden;
}
.about_callout__lvH50::before {
  content: "";
  position: absolute;
  inset: 0 auto 0 0;
  width: 4px;
  background: var(--kur-gold);
}
.about_callout__lvH50::after {
  content: "";
  position: absolute;
  top: -40%;
  right: -10%;
  width: 28rem;
  aspect-ratio: 1;
  border-radius: 50%;
  background: radial-gradient(closest-side, rgba(255, 215, 0, 0.12), transparent);
  pointer-events: none;
}
.about_callout__lvH50 p {
  position: relative;
  margin: 0;
  max-width: 62rem;
  font-size: clamp(1.05rem, 1rem + 0.35vw, 1.3rem);
  line-height: 1.65;
}

/* Mission */
.about_mission__JPh9F {
  margin: 0;
  padding: 0;
  list-style: none;
  display: grid;
  gap: var(--space-4);
  grid-template-columns: repeat(auto-fit, minmax(min(15rem, 100%), 1fr));
}
.about_missionCard__xEN34 {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  padding: var(--space-6) var(--space-5);
  border: 1px solid var(--color-border-on-dark);
  border-radius: var(--radius-md);
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.06), rgba(255, 255, 255, 0.015));
  transition: border-color var(--dur-fast) ease, transform var(--dur) var(--ease-out);
}
.about_missionCard__xEN34:hover {
  border-color: rgba(255, 215, 0, 0.55);
  transform: translateY(-4px);
}
.about_missionIndex__EpWFv {
  position: absolute;
  top: var(--space-5);
  right: var(--space-5);
  font-size: 0.8rem;
  letter-spacing: var(--tracking-eyebrow);
  color: var(--kur-gold);
}
.about_missionIcon__Ev6pW {
  width: 3rem;
  height: 3rem;
  opacity: 0.9;
}
.about_missionTitle__8UN8p {
  margin: var(--space-3) 0 0;
  font-size: var(--text-h3);
  font-weight: 500;
  color: #fff;
}
.about_missionText__2obg2 {
  margin: 0;
  line-height: var(--leading-body);
  color: var(--color-text-muted-on-dark);
}
@media (prefers-reduced-motion: reduce) {
  .about_missionCard__xEN34:hover {
    transform: none;
  }
}

/* Leadership */
.about_leaders__TtJXk {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(15rem, 100%), 1fr));
  gap: var(--space-6);
}
.about_leader__uwuCn:hover .about_portrait__5HClZ img {
  transform: scale(1.03);
}
.about_name__-dOPG {
  margin: var(--space-4) 0 var(--space-1);
  font-size: var(--text-h3);
  font-weight: 500;
}
.about_role__ZCD-B {
  margin: 0;
  color: var(--color-ink);
}
.about_company__zwU0k {
  margin: 0.15rem 0 0;
  font-size: 0.9rem;
  color: var(--color-text-muted);
}
.about_more__7URcd {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  justify-content: space-between;
  gap: var(--space-3);
  margin-top: clamp(2.5rem, 2rem + 2vw, 4rem);
  padding-top: var(--space-6);
  border-top: 1px solid var(--color-border);
}
.about_more__7URcd p {
  margin: 0;
  color: var(--color-text-muted);
}
.about_split__zhsFy > header {
  margin-bottom: 0;
}
`, "",{"version":3,"sources":["webpack://./src/PAGES/ABOUT/about.module.css"],"names":[],"mappings":"AAAA,iBAAiB;AACjB;EACE,SAAS;EACT,2BAA2B;EAC3B,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,kCAAkC;EAClC,iDAAiD;EACjD,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,sCAAsC;EACtC,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA,yCAAyC;AACzC;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE;IACE,oDAAoD;IACpD,2BAA2B;EAC7B;EACA;IACE,gBAAgB;IAChB,sDAAsD;IACtD,gBAAgB;EAClB;AACF;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,8BAA8B;EAC9B,gCAAgC;EAChC,8BAA8B;AAChC;AACA;EACE,SAAS;AACX;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,yCAAyC;EACzC,yCAAyC;EACzC,+BAA+B;EAC/B,4EAA4E;EAC5E,gCAAgC;EAChC,4BAA4B;EAC5B,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,UAAU;EACV,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,+EAA+E;EAC/E,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,gDAAgD;EAChD,iBAAiB;AACnB;;AAEA,YAAY;AACZ;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,sEAAsE;AACxE;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,sCAAsC;EACtC,6CAA6C;EAC7C,+BAA+B;EAC/B,0FAA0F;EAC1F,mFAAmF;AACrF;AACA;EACE,qCAAqC;EACrC,2BAA2B;AAC7B;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,iBAAiB;EACjB,uCAAuC;EACvC,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;AACA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,SAAS;EACT,gCAAgC;EAChC,sCAAsC;AACxC;AACA;EACE;IACE,eAAe;EACjB;AACF;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sEAAsE;EACtE,mBAAmB;AACrB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,uCAAuC;EACvC,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,uBAAuB;AACzB;AACA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,8BAA8B;EAC9B,mBAAmB;EACnB,2CAA2C;EAC3C,2BAA2B;EAC3B,yCAAyC;AAC3C;AACA;EACE,SAAS;EACT,8BAA8B;AAChC;AACA;EACE,gBAAgB;AAClB","sourcesContent":["/* Hero pillars */\n.pillars {\n  margin: 0;\n  padding: var(--space-5) 0 0;\n  list-style: none;\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--space-3) var(--space-6);\n  border-top: 1px solid var(--color-border-on-dark);\n  max-width: 46rem;\n}\n.pillars li {\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n  font-size: 0.95rem;\n  color: var(--color-text-muted-on-dark);\n  white-space: nowrap;\n}\n.pillars li::before {\n  content: \"\";\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: var(--kur-gold);\n  box-shadow: 0 0 10px rgba(255, 215, 0, 0.7);\n}\n\n/* Intro on the left, copy on the right */\n.split {\n  display: grid;\n  gap: var(--space-6);\n  align-items: start;\n}\n@media (min-width: 1024px) {\n  .split {\n    grid-template-columns: minmax(0, 5fr) minmax(0, 7fr);\n    gap: clamp(3rem, 6vw, 6rem);\n  }\n  .split > header {\n    position: sticky;\n    top: calc(var(--scroll-offset, 96px) + var(--space-4));\n    margin-bottom: 0;\n  }\n}\n.prose {\n  display: grid;\n  gap: var(--space-4);\n  max-width: 44rem;\n  font-size: var(--text-body-lg);\n  line-height: var(--leading-body);\n  color: var(--color-text-muted);\n}\n.prose p {\n  margin: 0;\n}\n.prose p:first-child {\n  color: var(--color-ink);\n}\n\n.callout {\n  position: relative;\n  margin: clamp(3rem, 2rem + 4vw, 5rem) 0 0;\n  padding: clamp(1.75rem, 1rem + 3vw, 3rem);\n  border-radius: var(--radius-lg);\n  background: linear-gradient(135deg, var(--color-ink), var(--color-ink-deep));\n  color: var(--color-text-on-dark);\n  box-shadow: var(--shadow-lg);\n  overflow: hidden;\n}\n.callout::before {\n  content: \"\";\n  position: absolute;\n  inset: 0 auto 0 0;\n  width: 4px;\n  background: var(--kur-gold);\n}\n.callout::after {\n  content: \"\";\n  position: absolute;\n  top: -40%;\n  right: -10%;\n  width: 28rem;\n  aspect-ratio: 1;\n  border-radius: 50%;\n  background: radial-gradient(closest-side, rgba(255, 215, 0, 0.12), transparent);\n  pointer-events: none;\n}\n.callout p {\n  position: relative;\n  margin: 0;\n  max-width: 62rem;\n  font-size: clamp(1.05rem, 1rem + 0.35vw, 1.3rem);\n  line-height: 1.65;\n}\n\n/* Mission */\n.mission {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  display: grid;\n  gap: var(--space-4);\n  grid-template-columns: repeat(auto-fit, minmax(min(15rem, 100%), 1fr));\n}\n.missionCard {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-3);\n  padding: var(--space-6) var(--space-5);\n  border: 1px solid var(--color-border-on-dark);\n  border-radius: var(--radius-md);\n  background: linear-gradient(180deg, rgba(255, 255, 255, 0.06), rgba(255, 255, 255, 0.015));\n  transition: border-color var(--dur-fast) ease, transform var(--dur) var(--ease-out);\n}\n.missionCard:hover {\n  border-color: rgba(255, 215, 0, 0.55);\n  transform: translateY(-4px);\n}\n.missionIndex {\n  position: absolute;\n  top: var(--space-5);\n  right: var(--space-5);\n  font-size: 0.8rem;\n  letter-spacing: var(--tracking-eyebrow);\n  color: var(--kur-gold);\n}\n.missionIcon {\n  width: 3rem;\n  height: 3rem;\n  opacity: 0.9;\n}\n.missionTitle {\n  margin: var(--space-3) 0 0;\n  font-size: var(--text-h3);\n  font-weight: 500;\n  color: #fff;\n}\n.missionText {\n  margin: 0;\n  line-height: var(--leading-body);\n  color: var(--color-text-muted-on-dark);\n}\n@media (prefers-reduced-motion: reduce) {\n  .missionCard:hover {\n    transform: none;\n  }\n}\n\n/* Leadership */\n.leaders {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(min(15rem, 100%), 1fr));\n  gap: var(--space-6);\n}\n.leader:hover .portrait img {\n  transform: scale(1.03);\n}\n.name {\n  margin: var(--space-4) 0 var(--space-1);\n  font-size: var(--text-h3);\n  font-weight: 500;\n}\n.role {\n  margin: 0;\n  color: var(--color-ink);\n}\n.company {\n  margin: 0.15rem 0 0;\n  font-size: 0.9rem;\n  color: var(--color-text-muted);\n}\n.more {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: var(--space-3);\n  margin-top: clamp(2.5rem, 2rem + 2vw, 4rem);\n  padding-top: var(--space-6);\n  border-top: 1px solid var(--color-border);\n}\n.more p {\n  margin: 0;\n  color: var(--color-text-muted);\n}\n.split > header {\n  margin-bottom: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pillars": `about_pillars__CrjT6`,
	"split": `about_split__zhsFy`,
	"prose": `about_prose__Y1IJk`,
	"callout": `about_callout__lvH50`,
	"mission": `about_mission__JPh9F`,
	"missionCard": `about_missionCard__xEN34`,
	"missionIndex": `about_missionIndex__EpWFv`,
	"missionIcon": `about_missionIcon__Ev6pW`,
	"missionTitle": `about_missionTitle__8UN8p`,
	"missionText": `about_missionText__2obg2`,
	"leaders": `about_leaders__TtJXk`,
	"leader": `about_leader__uwuCn`,
	"portrait": `about_portrait__5HClZ`,
	"name": `about_name__-dOPG`,
	"role": `about_role__ZCD-B`,
	"company": `about_company__zwU0k`,
	"more": `about_more__7URcd`
};
export default ___CSS_LOADER_EXPORT___;
